/**
 * Content for a provider / place detail page — the page type that holds
 * attention on the live site (SBCC Parenting Program: 2:16 average).
 */

export const provider = {
  name: 'SBCC Parenting Program',
  hub: 'Parenting resources',
  hubPath: '/parenting-resources-santa-barbara',
  path: '/parenting-resources-santa-barbara/sbcc-parenting-program',
  category: 'Parent support',
  neighborhood: 'Downtown & Goleta campuses',
  oneLiner:
    'Free, drop-in parent-and-child classes through Santa Barbara City College — the closest thing this town has to a built-in village.',
  updated: 'Checked August 2026',
  ages: '0–5 years',
  cost: 'Free (materials fee optional)',
  registration: 'Rolling — register any week of the term',
  bestFor: 'First-time parents, new-to-town families, rainy mornings',
  body: [
    'This is the first thing we recommend to anyone who has just moved here with a baby. You show up, your kid plays, and you sit in a circle with eight other parents who are having the same week you are. It is technically a college class, which is why it is free, and which is also why nobody seems to know about it.',
    'Classes are grouped by age, from infants through pre-K, and each meets once a week for about two hours. There is a facilitator, some structured circle time, and a long stretch of open play. The curriculum is real — you will leave with actual language for tantrums and sleep — but the honest value is the other parents.',
  ],
  goodToKnow: [
    'Sign up through the SBCC School of Extended Learning, not the main college portal',
    'Fall term fills in the first two weeks; spring is easier to get into',
    'The Downtown location has street parking only — budget ten extra minutes',
    'Siblings under 12 months can usually come along, but ask your facilitator',
  ],
  parentNotes: [
    {
      quote:
        'I moved here at 34 weeks pregnant and knew nobody. Three of the women from my Tuesday class are now the people I text at 6am.',
      author: 'Local mom, Mesa',
    },
    {
      quote:
        'The facilitator caught a speech delay in my son before our pediatrician did. That alone was worth showing up.',
      author: 'Local dad, Goleta',
    },
  ],
  nextSteps: [
    { label: 'Preschools & daycares in Santa Barbara', kind: 'Guide' },
    { label: 'Mom groups that actually meet', kind: 'Guide' },
    { label: 'Rainy day ideas for under-5s', kind: 'Guide' },
    { label: 'Free things to do with kids', kind: 'Guide' },
  ],
  faqs: [
    {
      question: 'Is the SBCC Parenting Program really free?',
      answer:
        'Yes. It is offered through SBCC’s School of Extended Learning, so there is no tuition. Some classes ask for a small optional materials donation, usually under $30 a term.',
    },
    {
      question: 'What ages does it cover?',
      answer:
        'Infant classes start at around six weeks, and classes run through pre-K. Children are grouped in roughly six-month bands for the first two years, then by year.',
    },
    {
      question: 'When should I register?',
      answer:
        'Registration opens a few weeks before each term and fall fills fastest. If your first choice is full, get on the waitlist — attrition in the first two weeks is high.',
    },
  ],
}
